export default "__VITE_ASSET__BjF1usN$__"